import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Animation for Hero Card - split: image slides from right, text from left
 */
export const animateHeroCard = (ref) => {
  if (ref.current) {
    const element = ref.current;
    const image = element.querySelector('img');
    const textContent = element.querySelector('[class*="textContent"]');
    
    // Set initial state immediately to prevent flash
    if (image) {
      gsap.set(image, { opacity: 0, x: 100 });
    }
    if (textContent) {
      gsap.set(textContent, { opacity: 0, x: -100 });
    }
    
    const timer = setTimeout(() => {
      if (image) {
        gsap.to(image, {
          opacity: 1,
          x: 0,
          duration: 1.2,
          ease: "power3.out",
          scrollTrigger: {
            trigger: element,
            start: "top 80%",
            toggleActions: "play none none none",
          },
        });
      }
      
      if (textContent) {
        gsap.to(textContent, {
          opacity: 1,
          x: 0,
          duration: 1.2,
          delay: 0.2,
          ease: "power3.out",
          scrollTrigger: {
            trigger: element,
            start: "top 80%",
            toggleActions: "play none none none",
          },
        });
      }
      ScrollTrigger.refresh();
    }, 100);
    
    return () => clearTimeout(timer);
  }
};

